import { datadogRum } from "@datadog/browser-rum"
import { hasPerformanceCookieConsent } from "./utils/cookie"

export default function initializeDatadogRum() {
  if (
    !import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN ||
    !import.meta.env.VITE_APP_DATADOG_APPLICATION_ID
  ) {
    console.warn(
      "Datadog RUM is not initialized because the client token or application ID is missing."
    )
    return
  }

  const hasConsent = hasPerformanceCookieConsent()

  datadogRum.init({
    applicationId: import.meta.env.VITE_APP_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_APP_DATADOG_CLIENT_TOKEN,
    site: "datadoghq.eu",
    service: "hts-webservices",
    env: import.meta.env.VITE_APP_ENV,
    allowedTracingUrls: import.meta.env.VITE_API_URL
      ? [(url) => url.startsWith(import.meta.env.VITE_API_URL as string)]
      : [],
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "mask-user-input",
    trackingConsent: hasConsent ? "granted" : "not-granted",
  })
}
